import { isInAriseApp } from '@ali/arise-h5-utils-env';
// @ts-ignore
import getDeviceType from '@ali/lzd-h5-device-type';
import { POPUP_TYPE } from './index-pc';

const toFixed = (number: number, precision = 2) => {
  const multiplier = Math.pow(10, precision + 1);
  const wholeNumber = Math.floor(number * multiplier);
  return (Math.round(wholeNumber / 10) * 10) / multiplier;
};
interface ITransferRpxToVw {
  (rpx: number, uiWidth?: number): string;
}

/**
 *
 * @param rpx ui 稿上元素大小
 * @param uiWidth ui 稿宽度
 * @returns rpx 转 vw 结果(带单位)
 */
export const transferRpxToVw: ITransferRpxToVw = (rpx, uiWidth = 360) => {
  return `${toFixed((rpx / uiWidth) * 100)}vw`;
};

/**
 * @description 获取相应机型 顶部安全区高度 vw
 * @returns 顶部安全区高度 带单位（vw）
 */
export function getStatusBarHeight(): string {
  if (isInAriseApp()) {
    const deviceType = getDeviceType();
    return deviceType === 'IPHONEX'
      ? transferRpxToVw(88, 750)
      : transferRpxToVw(40, 750);
  }
  return '0';
}

export function fatigue(limit: number, session: number): boolean {
  const { showTimes = 0, sessionTimes = null } = JSON.parse(
    localStorage.getItem('subscribePopupFatigue')
  ) as unknown as {
    showTimes: number;
    sessionTimes: number;
  };
  if (showTimes < limit && (session >= sessionTimes || session === null)) {
    localStorage.setItem(
      'subscribePopupFatigue',
      JSON.stringify({ sessionTimes: 0, showTimes: showTimes + 1 })
    );
    return true;
  }
  localStorage.setItem(
    'subscribePopupFatigue',
    JSON.stringify({ sessionTimes: sessionTimes + 1, showTimes: showTimes })
  );
  return false;
}

export function trigger({
  duration,
  scroll,
  callback,
}: {
  duration: number | string;
  scroll?: number | string;
  callback: () => void;
}) {
  const windowHeight = window.innerHeight;
  let timer: NodeJS.Timeout;
  const scrollHandler = () => {
    if (windowHeight * Number(scroll) > window.scrollY) {
      return;
    }
    if (timer) {
      clearTimeout(timer);
    }
    typeof callback === 'function' && callback();
    window.removeEventListener('scroll', scrollHandler);
  };
  timer =
    Number(duration) !== 0 &&
    setTimeout(() => {
      typeof callback === 'function' && callback();
      timer = null;
      Number(scroll) !== 0 &&
        window.removeEventListener('scroll', scrollHandler);
    }, Number(duration) * 1000);
  Number(scroll) !== 0 && window.addEventListener('scroll', scrollHandler);
}

/**
 * @description arr: className
 */
export function cls(arr: string[]) {
  return arr.filter((ele) => !!ele).join(' ');
}

export interface IFatigue {
  afterSessionCount: string;
  fatigue: string;
  type: string;
  nuVoucherSetup: string;
  nuVoucherFatigue: string;
  nuVoucherAfterSessionCount: string;
}

interface IStorage {
  empId: string,
  fatigue: IFatigue,
  callback: (show: boolean) => void,
}

const empIdStorage = ({
  empId,
  fatigue,
  callback,
}: IStorage) => {
  const { afterSessionCount, fatigue: maxTimes } = fatigue;
  let cfatigue: any = localStorage.getItem(empId);
  if (cfatigue) {
    try {
      cfatigue = JSON.parse(cfatigue);
      if (Number(cfatigue.fatigue) >= Number(maxTimes)) {
        callback(false);
      } else if (
        Number(cfatigue.afterSessionCount) < Number(afterSessionCount)
      ) {
        callback(false);
        cfatigue.afterSessionCount = Number(cfatigue.afterSessionCount) + 1;
        localStorage.setItem(empId, JSON.stringify(cfatigue));
      } else {
        callback(true);
        localStorage.setItem(
          empId,
          JSON.stringify({
            afterSessionCount: 0,
            fatigue: Number(cfatigue.fatigue) + 1,
          })
        );
      }
    } catch (error) {
      callback(false);
    }
  } else if (Number(maxTimes) > 0) {
    let empIdInfo = {
      afterSessionCount: 0,
      fatigue: 1,
    };
    localStorage.setItem(empId, JSON.stringify(empIdInfo));
    callback(true);
  } else {
    callback(false);
  }
}

const nuEmpIdStorage = ({
  empId,
  fatigue,
  callback,
}: IStorage) => {
  const { nuVoucherAfterSessionCount, nuVoucherFatigue: maxTimes, nuVoucherSetup } = fatigue;
  let cfatigue: any = localStorage.getItem(empId);

  const next = () => {
    if (Number(maxTimes) > 0) {
      let empIdInfo = {
        nuVoucherAfterSessionCount: 0,
        nuVoucherFatigue: 1,
        nuVoucherSetup,
      };
      localStorage.setItem(empId, JSON.stringify(empIdInfo));
      callback(true);
    } else {
      callback(false);
    }
  };

  if (cfatigue) {
    try {
      cfatigue = JSON.parse(cfatigue);
      switch (cfatigue.nuVoucherSetup === nuVoucherSetup) {
        case true:
          if (Number(cfatigue.nuVoucherFatigue) >= Number(maxTimes)) {
            callback(false);
          } else if (
            Number(cfatigue.nuVoucherAfterSessionCount) < Number(nuVoucherAfterSessionCount)
          ) {
            callback(false);
            cfatigue.nuVoucherAfterSessionCount = Number(cfatigue.nuVoucherAfterSessionCount) + 1;
            localStorage.setItem(empId, JSON.stringify(cfatigue));
          } else {
            callback(true);
            localStorage.setItem(
              empId,
              JSON.stringify({
                nuVoucherAfterSessionCount: 0,
                nuVoucherFatigue: Number(cfatigue.nuVoucherFatigue) + 1,
                nuVoucherSetup,
              })
            );
          }
          break;

        default:
          next();
          break;
      }
    } catch (error) {
      callback(false);
    }
  } else {
    next();
  }
}

export const NotLoggedId = 'empId-c7b38d2c-36ac-4b11-a3b6-1b71f74eedef';
/**
 * @description empId：用户工号,
 * callback(show: 是否展示popup)
 */
export async function Fatigue(
  fatigue: IFatigue,
  callback: (show: boolean) => void
) {
  const { type } = fatigue || {};
  const { userId } = (await window.jsapi?.login?.getUserInfo()) || {};
  let empId = userId || NotLoggedId;
  if (type === POPUP_TYPE.NU_VOUCHER) {
    empId = `nu-${empId}`;
    nuEmpIdStorage({
      empId,
      fatigue,
      callback,
    });
    return;
  }
  empIdStorage({
    empId,
    fatigue,
    callback,
  });
}

/** 使用递归的方式实现参数的深拷贝 */
export function deepCopy(obj: any): any {
  let result: any;
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      result = [];
      for (let i = 0; i < obj.length; i++) {
        result[i] = deepCopy(obj[i]);
      }
    } else {
      result = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          result[key] = deepCopy(obj[key]);
        }
      }
    }
  } else {
    result = obj;
  }
  return result;
}
